import Vue from "vue";
import VueRouter from "vue-router";
import Add from "../views/Add.vue";
import Find from "../views/Find.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/add",
    name: "Add",
    component: Add,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    beforeEnter: (to, from, next) => {
      let params = new URLSearchParams(to.hash.substring(1));
      if (params.get("id_token")) {
        window.localStorage.setItem(
          "id_token",
          JSON.stringify({
            t: params.get("id_token"),
            exp: new Date().getTime() + 45 * 60 * 1000
          })
        );
      }
      next(window.localStorage.getItem("redirect"));
    }
  },
  {
    path: "/find",
    name: "Find",
    component: Find,
    meta: {
      requiresAuth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta?.requiresAuth) {
    next();
    return;
  }
  if (window.localStorage.getItem("id_token")) {
    let t = JSON.parse(window.localStorage.getItem("id_token"));
    if (t.exp < new Date().getTime()) {
      window.localStorage.removeItem("id_token");
    } else {
      next();
      return;
    }
  }

  window.localStorage.setItem("redirect", to.fullPath);
  document.location.href =
    "https://accounts.google.com/o/oauth2/v2/auth" +
    "?client_id=853077211790-ora0jp2l18gm8v7m03lq3v93f4ej950f.apps.googleusercontent.com" +
    "&redirect_uri=" +
    window.location.origin +
    "/login" +
    "&response_type=id_token&scope=email%20openid&nonce=foobar";
});

export default router;
